/*
 * Divara storefront fixes (draft theme, 2026-11-03). Loaded once from snippets/dv-cart-promos.liquid.
 *  1. Cart drawer empty state: dv-personalise.js refreshCart() swaps the drawer HTML but never toggles
 *     .is-empty, so removing the last piece (with shipping protection on) left a blank R0.00 drawer.
 *  2. Cart upsell add (button [data-dv-upsell-go]): follows each product's Personalisation text setting,
 *     so birthstone-only pieces never ask for (or send) a name, and initials send "Initial".
 *  3. Names & birthstones block ([data-dv-multi]): show/hide rows for the chosen number of names + validation.
 *  4. "Two necklaces": shows the second-necklace error at the same time as the first necklace's errors.
 *  5. Initial fields: letters only, upper case.
 */
(function () {
  if (window.__dvFixes) return;
  window.__dvFixes = true;

  /* ---------- 1. Empty-state sync ---------- */
  function syncEmpty() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var empty = !!drawer.querySelector('.drawer__inner-empty');
    if (drawer.classList.contains('is-empty') !== empty) drawer.classList.toggle('is-empty', empty);
  }

  function refreshDrawer() {
    if (document.querySelector('cart-items:not(cart-drawer-items), #main-cart-items')) {
      window.location.reload();
      return Promise.resolve();
    }
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var parse = function (html) { return new DOMParser().parseFromString(html, 'text/html'); };
        if (sections['cart-drawer']) {
          var target = document.querySelector('#CartDrawer .drawer__inner');
          var source = parse(sections['cart-drawer']).querySelector('#CartDrawer .drawer__inner');
          if (target && source) target.innerHTML = source.innerHTML;
        }
        if (sections['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          var bubbleSrc = parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
          if (bubble && bubbleSrc) bubble.innerHTML = bubbleSrc.innerHTML;
        }
        syncEmpty();
      });
  }

  /* ---------- 2. Cart upsell ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-dv-upsell-go]');
    if (!btn) return;
    e.preventDefault();
    var box = btn.closest('[data-dv-upsell]');
    var err = box.querySelector('[data-dv-upsell-error]');
    var fail = function (msg, el) {
      err.textContent = msg;
      err.hidden = false;
      if (el) el.focus();
    };
    err.hidden = true;

    var properties = {};
    var fields = box.querySelectorAll('[data-dv-upsell-field]');
    for (var i = 0; i < fields.length; i++) {
      var value = fields[i].value.trim();
      if (!value) return fail('Please enter ' + fields[i].dataset.label + '.', fields[i]);
      properties[fields[i].dataset.prop] = value;
    }

    var month = box.querySelector('[data-dv-month-select]');
    if (month && !month.value) return fail('Please choose your birthstone.', month);
    var stones = box.querySelectorAll('[data-dv-upsell-prop]');
    for (var j = 0; j < stones.length; j++) {
      if (!stones[j].value) {
        return fail(stones.length > 1 ? 'Please choose each birthstone.' : 'Please choose your birthstone.', stones[j]);
      }
      properties[stones[j].dataset.dvUpsellProp] = stones[j].value;
    }

    // Let dv-personalise.js map colour + month to the right variant before reading it
    if (month) month.dispatchEvent(new Event('change', { bubbles: true }));
    var variantId = box.querySelector('[data-dv-upsell-variant]').value;
    if (!variantId) return fail('That option is unavailable. Please choose another.');

    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1, properties: properties }] })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || 'Could not add to cart.');
          return data;
        });
      })
      .then(refreshDrawer)
      .catch(function (error) {
        fail(error.message || 'Could not add to cart. Please try again.');
        btn.disabled = false;
        btn.textContent = btn.dataset.label || 'Add';
      });
  });

  /* ---------- 3. Names & birthstones ---------- */
  function multiSync(box) {
    var picked = box.querySelector('[data-dv-multi-count]:checked');
    var count = parseInt(picked ? picked.value : '1', 10);
    var total = box.querySelector('[data-dv-multi-total]');
    if (total) total.value = count;
    box.querySelectorAll('[data-dv-multi-row]').forEach(function (row) {
      var on = parseInt(row.dataset.dvMultiRow, 10) <= count;
      row.hidden = !on;
      row.querySelectorAll('input, select').forEach(function (el) { el.disabled = !on; });
      if (!on) {
        row.querySelector('[data-dv-multi-error]').hidden = true;
        row.classList.remove('dv-field--invalid');
      }
    });
  }

  function clearRow(el) {
    var row = el.closest('[data-dv-multi-row]');
    if (!row) return;
    var name = row.querySelector('[data-dv-multi-name]').value.trim();
    var stone = row.querySelector('[data-dv-multi-stone]').value;
    if (name && stone) {
      row.querySelector('[data-dv-multi-error]').hidden = true;
      row.classList.remove('dv-field--invalid');
    }
  }

  function multiInvalid(box) {
    var first = null;
    box.querySelectorAll('[data-dv-multi-row]').forEach(function (row) {
      if (row.hidden) return;
      var n = row.dataset.dvMultiRow;
      var nameEl = row.querySelector('[data-dv-multi-name]');
      var stoneEl = row.querySelector('[data-dv-multi-stone]');
      var err = row.querySelector('[data-dv-multi-error]');
      nameEl.value = nameEl.value.trim();
      var msg = '';
      if (!nameEl.value) msg = 'Please enter name ' + n + '.';
      else if (!stoneEl.value) msg = 'Please choose a birthstone for name ' + n + '.';
      err.textContent = msg;
      err.hidden = !msg;
      row.classList.toggle('dv-field--invalid', !!msg);
      if (msg && !first) first = nameEl.value ? stoneEl : nameEl;
    });
    return first;
  }

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-dv-multi-count]')) multiSync(e.target.closest('[data-dv-multi]'));
    if (e.target.matches('[data-dv-multi-stone]')) clearRow(e.target);
  });

  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-dv-multi-name]')) clearRow(e.target);
    /* 5. Initials: letters only, upper case */
    if (e.target.matches('[data-dv-initial]')) {
      var v = e.target.value.replace(/[^A-Za-z]/g, '').toUpperCase();
      if (v !== e.target.value) {
        e.target.value = v;
        e.target.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }
  });

  /* ---------- 4. Second necklace hint ---------- */
  function pairHint(box) {
    var err = box.querySelector('[data-dv-pair-error]');
    if (!err) return;
    var name = box.querySelector('[data-dv-pair-name]');
    var month = box.querySelector('[data-dv-month-select]');
    var msg = '';
    if (!name || !name.value.trim()) msg = 'Please enter a name for your second necklace.';
    else if (month && !month.value) msg = 'Please choose a birthstone for your second necklace.';
    if (msg) {
      err.textContent = msg;
      err.hidden = false;
      box.classList.add('dv-field--invalid');
    }
  }

  /* Add-to-cart guard: window capture runs before dv-personalise.js and the theme's product form */
  function isAddButton(btn) {
    if (!btn || btn.closest('#CartDrawer')) return false;
    if (btn.name === 'add' || btn.classList.contains('main-product-atc')) return true;
    var form = btn.form;
    return !!(form && /\/cart\/add/.test(form.getAttribute('action') || '') && btn.type === 'submit');
  }

  function guard(e) {
    var multi = document.querySelector('main [data-dv-multi]');
    var pair = document.querySelector('[data-dv-pair-second]:not([hidden])');
    if (!multi && !pair) return;
    if (e.type === 'click') {
      if (!isAddButton(e.target.closest && e.target.closest('button'))) return;
    } else if (!/\/cart\/add/.test((e.target.getAttribute && e.target.getAttribute('action')) || '')) {
      return;
    }
    if (pair) pairHint(pair);
    if (multi) {
      var bad = multiInvalid(multi);
      if (bad) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var y = bad.getBoundingClientRect().top + window.scrollY - window.innerHeight / 3;
        window.scrollTo({ top: Math.max(y, 0), behavior: 'smooth' });
        bad.focus({ preventScroll: true });
      }
    }
  }
  window.addEventListener('click', guard, true);
  window.addEventListener('submit', guard, true);

  function start() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      new MutationObserver(syncEmpty).observe(drawer, { childList: true, subtree: true });
      syncEmpty();
    }
    document.querySelectorAll('[data-dv-multi]').forEach(multiSync);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
